import React from "react";
import SelectComponent from "../../../../components/ui/textfield/selectComponent";
import { t } from "i18next";
import dataBankTransfer from "./bankTransfer.json";
function BankTransferOptions({ props }) {
  let {
    watch,
    setValue,
    errors,
    clearErrors,
    control,
    dataChannel,
    dataAllEditSelections,
  } = props;
  const onSelectBankTransfer = (value) => {
    setValue("selectDelivery", value);
    clearErrors("selectDelivery");

    if (value === 1) {
      setValue("bankTransferName", "Bank Transfer");
      setValue("bankTransferNameAlt", "Bank Transfer");
    }
    if (value === 2) {
      setValue("bankTransferName", "Thai QR");
      setValue("bankTransferNameAlt", "Thai QR");
    }
    setValue("selectDelivery", value);
    clearErrors("selectDelivery");
  };
  const compareArray = dataBankTransfer.filter(
    (item) =>
      !dataChannel.some(
        (fItem) => fItem.payment_channel_lang.name === item.name
      )
  );
  return (
    <div>
      <SelectComponent
        watch={watch}
        title={t("payment_channel")}
        name="selectDelivery"
        errors={errors}
        setValue={setValue}
        dataEmpty={t("payment_channel_select")}
        optionsData={
          dataAllEditSelections ? dataAllEditSelections : compareArray
        }
        onFunctionName={onSelectBankTransfer}
        disabled={
          dataAllEditSelections
            ? dataAllEditSelections.length === 0
            : compareArray.length === 0
        }
        clearErrors={clearErrors}
        control={control}
      />
    </div>
  );
}

export default BankTransferOptions;
